import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

import { CheckboxComponent } from '@shared/components/checkbox/checkbox.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';

export interface IAgCheckboxParams extends ICellRendererParams {
  dontSelectRow?: boolean;
  getDisabledState?: (params: IAgCheckboxParams) => boolean;
  hideLabel?: boolean;
  isHidden?: boolean;
  onChanges?: (params: IAgCheckboxParams) => void;
  tooltip?: string;
  tooltipFN?: (params: IAgCheckboxParams) => string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CheckboxComponent, FormsModule, TooltipDirective, AsyncPipe],
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  template: `
    @if (!params.isHidden) {
      <div class="flex items-center justify-center" style="height: 30px">
        <aux-checkbox
          [disabled]="(disabled$ | async) === true"
          [indeterminate]="indeterminate"
          [(ngModel)]="val"
          (ngModelChange)="onChange($event)"
          [auxTooltip]="(disabled$ | async) === true ? tooltip : ''"
          [hideLabel]="params.hideLabel"
        />
      </div>
    }
  `,
})
export class AgCheckboxRendererComponent implements ICellRendererAngularComp {
  disabled$ = new BehaviorSubject(false);
  indeterminate = false;
  params!: IAgCheckboxParams;
  tooltip = '';
  val!: boolean;

  agInit(params: IAgCheckboxParams) {
    this.params = params;
    this.val = params.value;

    if (params.tooltip) {
      this.tooltip = params.tooltip;
    }

    if (params.tooltipFN) {
      this.tooltip = params.tooltipFN(params);
    }

    if (params.value === 'indeterminate') {
      this.indeterminate = true;
      this.val = false;
    }

    if (params.getDisabledState) {
      this.disabled$.next(params.getDisabledState(this.params));
    }
  }

  onChange(e: boolean) {
    this.indeterminate = false;

    if (this.params.colDef?.field) {
      this.params.node.setDataValue(this.params.colDef.field, e);
    }

    if (!this.params.dontSelectRow) {
      this.params.node.setSelected(e);
    }

    if (this.params.onChanges) {
      this.params.onChanges(this.params);
    }
  }

  refresh(): boolean {
    return false;
  }
}
